"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaBlockRequestToJSON = exports.RosettaBlockRequestFromJSONTyped = exports.RosettaBlockRequestFromJSON = void 0;
const _1 = require("./");
function RosettaBlockRequestFromJSON(json) {
    return RosettaBlockRequestFromJSONTyped(json, false);
}
exports.RosettaBlockRequestFromJSON = RosettaBlockRequestFromJSON;
function RosettaBlockRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'network_identifier': _1.NetworkIdentifierFromJSON(json['network_identifier']),
        'block_identifier': json['block_identifier'],
    };
}
exports.RosettaBlockRequestFromJSONTyped = RosettaBlockRequestFromJSONTyped;
function RosettaBlockRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'network_identifier': _1.NetworkIdentifierToJSON(value.network_identifier),
        'block_identifier': value.block_identifier,
    };
}
exports.RosettaBlockRequestToJSON = RosettaBlockRequestToJSON;
//# sourceMappingURL=RosettaBlockRequest.js.map